import { __decorate, __metadata } from "tslib";
import { DocumentStatus } from '@cbbt/itf-onboarding-common';
import { BaseMessage, Field } from '@cbbt/lib-interface';
import { DocumentDetail } from './DocumentDetail.js';
export class DocumentResponse extends BaseMessage {
    id;
    journeyId;
    individualId;
    organisationId;
    caseId;
    processCode;
    caseReferenceNo;
    documentType;
    documentTypeId;
    documentId;
    document;
    ocisEvidenceTypeCode;
    ocisEvidencePurposeCode;
    caseStatus;
    casePartyID;
    externalSystemId;
    uploadSequenceNo;
    evidenceTypeCode;
    documentCode;
    tmpSysFileRefNum;
    fileName;
    fileSize;
    contentType;
    status;
    journeyDocumentStatus;
    fileComments;
    createdBy;
    docUploadCreatedDate;
    docUploadUpdateDate;
    previewCount;
    srcSessionId;
    requestedSource;
    sentToCase;
    documentDetail;
    createdOwner;
    updatedBy;
    isBranchScanned;
}
__decorate([
    Field.string({
        description: 'Unique id',
        required: true,
        format: 'uuid',
    }),
    __metadata("design:type", String)
], DocumentResponse.prototype, "id", void 0);
__decorate([
    Field.string({
        required: true,
        description: 'Unique journey id for different journey',
        minLength: 1,
    }),
    __metadata("design:type", String)
], DocumentResponse.prototype, "journeyId", void 0);
__decorate([
    Field.string({
        description: 'Individual id',
    }),
    __metadata("design:type", String)
], DocumentResponse.prototype, "individualId", void 0);
__decorate([
    Field.string({
        description: 'Organisation id',
    }),
    __metadata("design:type", String)
], DocumentResponse.prototype, "organisationId", void 0);
__decorate([
    Field.number({
        description: 'Case id',
        required: true,
        numberType: 'number',
    }),
    __metadata("design:type", Number)
], DocumentResponse.prototype, "caseId", void 0);
__decorate([
    Field.string({ required: true, description: 'ProcessCode' }),
    __metadata("design:type", String)
], DocumentResponse.prototype, "processCode", void 0);
__decorate([
    Field.string({ required: true, description: 'Case Reference No' }),
    __metadata("design:type", String)
], DocumentResponse.prototype, "caseReferenceNo", void 0);
__decorate([
    Field.string({ required: true, description: 'Document Type' }),
    __metadata("design:type", String)
], DocumentResponse.prototype, "documentType", void 0);
__decorate([
    Field.string({ required: true, description: 'Document Type Id' }),
    __metadata("design:type", String)
], DocumentResponse.prototype, "documentTypeId", void 0);
__decorate([
    Field.string({
        required: false,
        description: 'Document Id',
    }),
    __metadata("design:type", String)
], DocumentResponse.prototype, "documentId", void 0);
__decorate([
    Field.string({
        required: false,
        description: 'Document',
    }),
    __metadata("design:type", String)
], DocumentResponse.prototype, "document", void 0);
__decorate([
    Field.string({
        required: false,
        description: 'Ocis Evidence Type Code',
    }),
    __metadata("design:type", String)
], DocumentResponse.prototype, "ocisEvidenceTypeCode", void 0);
__decorate([
    Field.string({
        required: false,
        description: 'Ocis Evidence Purpose Code',
    }),
    __metadata("design:type", String)
], DocumentResponse.prototype, "ocisEvidencePurposeCode", void 0);
__decorate([
    Field.string({ required: true, description: 'caseStatus' }),
    __metadata("design:type", String)
], DocumentResponse.prototype, "caseStatus", void 0);
__decorate([
    Field.number({
        description: 'casePartyID',
        required: true,
        numberType: 'number',
    }),
    __metadata("design:type", Number)
], DocumentResponse.prototype, "casePartyID", void 0);
__decorate([
    Field.number({
        required: true,
        description: 'externalSystemId',
        numberType: 'number',
    }),
    __metadata("design:type", Number)
], DocumentResponse.prototype, "externalSystemId", void 0);
__decorate([
    Field.number({
        required: true,
        description: 'uploadSequenceNo',
        numberType: 'number',
    }),
    __metadata("design:type", Number)
], DocumentResponse.prototype, "uploadSequenceNo", void 0);
__decorate([
    Field.string({ required: true, description: 'evidenceTypeCode' }),
    __metadata("design:type", String)
], DocumentResponse.prototype, "evidenceTypeCode", void 0);
__decorate([
    Field.string({ required: true, description: 'documentCode' }),
    __metadata("design:type", String)
], DocumentResponse.prototype, "documentCode", void 0);
__decorate([
    Field.string({ required: true, description: 'tmpSysFileRefNum' }),
    __metadata("design:type", String)
], DocumentResponse.prototype, "tmpSysFileRefNum", void 0);
__decorate([
    Field.string({ required: true, description: 'fileName' }),
    __metadata("design:type", String)
], DocumentResponse.prototype, "fileName", void 0);
__decorate([
    Field.number({ required: true, description: 'fileSize', numberType: 'number' }),
    __metadata("design:type", Number)
], DocumentResponse.prototype, "fileSize", void 0);
__decorate([
    Field.string({ required: true, description: 'contentType' }),
    __metadata("design:type", String)
], DocumentResponse.prototype, "contentType", void 0);
__decorate([
    Field.string({
        description: 'status',
        required: false,
    }),
    __metadata("design:type", String)
], DocumentResponse.prototype, "status", void 0);
__decorate([
    Field.enum({
        enum: DocumentStatus,
        description: 'Journey Document Status',
        required: false,
    }),
    __metadata("design:type", String)
], DocumentResponse.prototype, "journeyDocumentStatus", void 0);
__decorate([
    Field.string({
        description: 'fileComments',
    }),
    __metadata("design:type", String)
], DocumentResponse.prototype, "fileComments", void 0);
__decorate([
    Field.string({
        description: 'createdBy',
    }),
    __metadata("design:type", String)
], DocumentResponse.prototype, "createdBy", void 0);
__decorate([
    Field.string({
        description: 'createdDate',
    }),
    __metadata("design:type", String)
], DocumentResponse.prototype, "docUploadCreatedDate", void 0);
__decorate([
    Field.string({
        description: 'updateDate',
    }),
    __metadata("design:type", String)
], DocumentResponse.prototype, "docUploadUpdateDate", void 0);
__decorate([
    Field.string({ required: true, description: 'previewCount' }),
    __metadata("design:type", String)
], DocumentResponse.prototype, "previewCount", void 0);
__decorate([
    Field.string({ required: true, description: 'srcSessionId' }),
    __metadata("design:type", String)
], DocumentResponse.prototype, "srcSessionId", void 0);
__decorate([
    Field.string({
        description: 'requestedSource by CWA or CASE',
    }),
    __metadata("design:type", String)
], DocumentResponse.prototype, "requestedSource", void 0);
__decorate([
    Field.boolean({
        description: 'Flag for document sent to case',
    }),
    __metadata("design:type", Boolean)
], DocumentResponse.prototype, "sentToCase", void 0);
__decorate([
    Field.message({
        description: 'Document details',
        required: false,
    }),
    __metadata("design:type", DocumentDetail)
], DocumentResponse.prototype, "documentDetail", void 0);
__decorate([
    Field.string({
        required: false,
        description: 'User ID',
        format: 'uuid',
    }),
    __metadata("design:type", String)
], DocumentResponse.prototype, "createdOwner", void 0);
__decorate([
    Field.string({
        required: false,
        description: 'User ID',
        format: 'uuid',
    }),
    __metadata("design:type", String)
], DocumentResponse.prototype, "updatedBy", void 0);
__decorate([
    Field.boolean({
        description: 'Is document scanned at branch',
        required: false,
    }),
    __metadata("design:type", Boolean)
], DocumentResponse.prototype, "isBranchScanned", void 0);
//# sourceMappingURL=DocumentResponse.js.map